module.exports = __webpack_public_path__ + "static/img/middleItem2.819f24b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/modularMain/middleItem2.png
// module id = H2nB
// module chunks = 31